
import { i18nText } from '@/locales';
import Vue from 'vue';
import Component from 'vue-class-component';
import { ITableColumn } from '@/entity/table/table.types';

@Component
export class TableColumns extends Vue {
    get columnsClients(): ITableColumn[] {
        return [
            {
                title: i18nText("Имя"),
                key: "name",
                dataIndex: "name",
                scopedSlots: {
                    filterDropdown: "filterDropdown",
                    filterIcon: "filterIcon",
                    customRender: "name",
                },
            },
            {
                title: i18nText("Номер телефона"),
                key: "phone",
                dataIndex: "phone",
                scopedSlots: {
                    filterDropdown: "filterDropdown",
                    filterIcon: "filterIcon",
                    customRender: "phone",
                },
            },
            {
                title: i18nText("Посещений"),
                key: "visits_count",
                dataIndex: "visits_count",
                scopedSlots: {
                    filterDropdown: "filterDropdown",
                    filterIcon: "filterIcon",
                },
            },
            {
                title: i18nText("Продано"),
                key: "sold",
                dataIndex: "sold",
                scopedSlots: {
                    filterDropdown: "filterDropdown",
                    filterIcon: "filterIcon",
                },
            },
            {
                title: i18nText("Последний визит"),
                key: "visit_last_date",
                dataIndex: "visit_last_date",
                scopedSlots: {
                    filterDropdown: "filterDropdown",
                    filterIcon: "filterIcon",
                },
            },
            {
                title: i18nText("Дата регистрации"),
                key: "created_at",
                dataIndex: "created_at",
                scopedSlots: {
                    filterDropdown: "filterDropdown",
                    filterIcon: "filterIcon",
                    customRender: "created_at",
                },
            },
        ];
    }

    get columnsAccounts(): ITableColumn[] {
        return [
            {
                title: i18nText("Владелец счета"),
                dataIndex: 'client',
                //key: 'client.id',
                key: 'client_name',
                scopedSlots: {
                    filterDropdown: "filterDropdown",
                    filterIcon: "filterIcon",
                    customRender: "ClientColumn",
                },
            },
            {
                title: i18nText("Баланс"),
                dataIndex: 'balance',
                key: 'balance',
                scopedSlots: {
                    filterDropdown: "filterDropdown",
                    filterIcon: "filterIcon",
                    customRender: "balance",
                },
            },
            {
                title: i18nText("Сумма пополнений"),
                dataIndex: 'refill_sum',
                key: 'refill_sum',
                scopedSlots: {
                    filterDropdown: "filterDropdown",
                    filterIcon: "filterIcon",
                    customRender: "refill_sum",
                },
            },
            {
                title: i18nText("Сумма списаний"),
                dataIndex: 'writeoff_sum',
                key: 'writeoff_sum',
                scopedSlots: {
                    filterDropdown: "filterDropdown",
                    filterIcon: "filterIcon",
                    customRender: "writeoff_sum",
                },
            }
        ];
    }
}
